import type { ContactEmailStatus } from './emails';

export enum ConnectionRequestDirection {
  Sent = 'sent',
  Received = 'received',
  All = 'all',
}

export enum ConnectionRequestType {
  ConnectionRequest = 'connection_request',
  Invite = 'invite',
}

export enum ConnectionRequestOrgRole {
  Client = 'client',
  Supplier = 'supplier',
}

export enum ConnectionRequestStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  Expired = 'expired',
}

export type ConnectionRequest = {
  id: string;
  supplierID: string;
  clientID: string;
  sentByID: string;
  message: string | null;
  type: ConnectionRequestType;
  primerEmail: boolean;
  contactName: string | null;
  contactEmail: string | null;
  status: ConnectionRequestStatus;
  statusUpdatedAt: string | null;
  statusUpdatedBy: string | null;
  expiresAt: string | null;
  rejectionMessage: string | null;
  createdAt: string | null;
  createdBy: string | null;
};

// These are returned by POST /connection-requests/search

type OrgSummary = {
  name: string;
  logo: string;
};

type UserSummary = {
  name: string;
  email: string;
};

export type ConnectionRequestAggregate = ConnectionRequest & {
  org: OrgSummary | null;
  sentBy: UserSummary | null;
  contactEmailStatus: ContactEmailStatus[] | null;
};

export type LatestConnectionRequest = ConnectionRequestAggregate & {
  direction?: ConnectionRequestDirection;
};
